import React from 'react';
import 'twin.macro';
import { Menu } from 'components/Menu';
import {
  PencilIcon as Pencil,
  TrashIcon as Trash,
} from '@heroicons/react/24/outline';
import { elevesUrls } from 'containers/Eleves/urls';
import { useDeleteElevesView } from 'queries/eleves/views/useDeleteElevesView';
import { useRenameViewModal } from 'containers/Eleves/List/Table/Views/RenameView/useRenameViewModal';
import { useDragListeners } from './SortableItem';
import { useSchoolGoTo } from 'containers/App/useSchoolGoTo';
import { ElevesView } from 'types/eleves';
import { useTranslation } from 'react-i18next';
import { activeItemStyle } from 'components/Tabs/TabsWithUnderline';

interface Props {
  view: ElevesView;
}

export function ActiveItem(props: Props) {
  const { view } = props;
  const { t } = useTranslation(['common']);
  const dragLi = useDragListeners();
  const goTo = useSchoolGoTo();
  const deleteView = useDeleteElevesView();
  const { openRenameViewModal } = useRenameViewModal();
  return (
    <Menu portal>
      <div
        {...(dragLi?.listeners || {})}
        tw="flex items-center h-full touch-none hover:bg-neutral-quiet rounded-t-lg"
      >
        <Menu.Span css={activeItemStyle}>{view.name}</Menu.Span>
      </div>
      <Menu.Items>
        <Menu.Item
          text={t('common:buttons.rename')}
          icon={Pencil}
          onClick={() => openRenameViewModal(view)}
        />
        <Menu.Item
          text={t('common:buttons.delete')}
          intent="danger"
          icon={Trash}
          onClick={() =>
            deleteView({ viewId: view.id }).then(() => {
              goTo(elevesUrls.views());
            })
          }
        />
      </Menu.Items>
    </Menu>
  );
}
